import { render, staticRenderFns } from "./moneyBack_trim.vue?vue&type=template&id=b8a645e0"
import script from "./moneyBack_trim.vue?vue&type=script&lang=js"
export * from "./moneyBack_trim.vue?vue&type=script&lang=js"
import style0 from "./moneyBack_trim.vue?vue&type=style&index=0&id=b8a645e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports